<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'reporting.reports.selectDateRange' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input
                    matStartDate
                    name="startDate"
                    #startDateInput="ngModel"
                    required
                    [(ngModel)]="startDate"
                    placeholder="{{ 'reporting.reports.startDate' | translate }}"
                />
                <input
                    matEndDate
                    name="endDate"
                    #endDateInput="ngModel"
                    required
                    [(ngModel)]="endDate"
                    placeholder="{{ 'reporting.reports.endDate' | translate }}"
                />
            </mat-date-range-input>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-error *ngIf="startDateInput.invalid && startDateInput.touched">{{
                startDateInput.errors | formErrors
            }}</mat-error>
            <mat-error *ngIf="endDateInput.invalid && endDateInput.touched">{{
                endDateInput.errors | formErrors
            }}</mat-error>
        </mat-form-field>
    </div>
    <div class="app-grid" *ngIf="!withMultiTimeOffTypes">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectTimeOffType' | translate }}</mat-label>
            <mat-select
                name="timeOffTypeField"
                #timeOffTypeField="ngModel"
                [(ngModel)]="selectedTimeOffTypeId"
                placeholder="{{ 'reporting.reports.timeOffTypes' | translate }}"
            >
                <mat-option *ngFor="let timeOffType of timeOffTypes" [value]="timeOffType.id">{{
                    timeOffType.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid" *ngIf="withMultiTimeOffTypes">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectTimeOffTypes' | translate }}</mat-label>
            <mat-select
                name="timeOffTypesField"
                #timeOffTypeField="ngModel"
                [(ngModel)]="selectedTimeOffTypesId"
                placeholder="{{ 'reporting.reports.timeOffTypes' | translate }}"
                multiple
            >
                <mat-option *ngFor="let timeOffType of timeOffTypes" [value]="timeOffType.id">{{
                    timeOffType.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid" *ngIf="hasImprovedTimeOffReports">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectRequestStatus' | translate }}</mat-label>
            <mat-select
                name="includePending"
                [(ngModel)]="includePending"
                placeholder="{{ 'reporting.reports.timeOffTypes' | translate }}"
            >
                <mat-option [value]="false">{{ 'reporting.reports.approvedOnly' | translate }}</mat-option>
                <mat-option [value]="true">{{ 'reporting.reports.pendingAndApproved' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectEmployeeStatus' | translate }}</mat-label>
            <mat-select
                [(ngModel)]="status"
                name="statusField"
                #statusField="ngModel"
                placeholder="{{ 'reporting.reports.status' | translate }}"
            >
                <mat-option [value]=""></mat-option>
                <mat-option value="active">{{ 'employeeStatus.active' | translate }}</mat-option>
                <mat-option value="onboarding">{{ 'employeeStatus.onboarding' | translate }}</mat-option>
                <mat-option value="terminated">{{ 'employeeStatus.terminated' | translate }}</mat-option>
                <mat-option value="onLeave">{{ 'employeeStatus.onLeave' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectDepartment' | translate }}</mat-label>
            <mat-select
                name="departmentField"
                [(ngModel)]="selectedDepartmentId"
                #departmentField="ngModel"
                placeholder="{{ 'reporting.reports.department' | translate }}"
            >
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let department of departments" [value]="department.id">{{
                    department.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectManager' | translate }}</mat-label>
            <mat-select
                name="managerField"
                [(ngModel)]="selectedManagerId"
                #managerField="ngModel"
                placeholder="{{ 'reporting.reports.manager' | translate }}"
            >
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let manager of managers" [value]="manager.id">{{ manager.fullName }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectOffice' | translate }}</mat-label>
            <mat-select
                name="office"
                [(ngModel)]="selectedOfficeId"
                #office="ngModel"
                placeholder="{{ 'reporting.reports.office' | translate }}"
            >
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let office of offices" [value]="office.id">{{ office.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="app-grid" *ngIf="!hasImprovedTimeOffReports">
        <mat-checkbox name="includePending" [(ngModel)]="includePending" class="columns-3">
            <span>{{ 'reporting.reports.includePendingRequests' | translate }}</span>
        </mat-checkbox>
    </div>
</form>
